import { useTranslation } from 'react-i18next'
import { GIFTS, getGiftImageUrl } from '../lib/gifts'
import './GiftModal.css'

const GiftModal = ({ onClose, onSelectGift }) => {
  const { t } = useTranslation()
  const handleGiftClick = (gift) => {
    onSelectGift?.(gift)
  }

  return (
    <div className="gift-modal-overlay" onClick={onClose}>
      <div className="gift-modal" onClick={(e) => e.stopPropagation()}>
        <div className="gift-modal-header">
          <h2 className="gift-modal-title">{t('gift.title')}</h2>
          <p className="gift-modal-subtitle">{t('gift.subtitle')}</p>
          <button type="button" className="gift-modal-close" onClick={onClose} aria-label={t('common.close')}>
            ✕
          </button>
        </div>
        <div className="gift-modal-grid">
          {GIFTS.map((gift) => (
            <button
              key={gift.id}
              type="button"
              className="gift-modal-item"
              onClick={() => handleGiftClick(gift)}
            >
              <div className="gift-modal-item-image">
                <img src={getGiftImageUrl(gift)} alt={gift.name} />
              </div>
              <span className="gift-modal-item-price">
                ${Number(gift.price).toFixed(2)}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default GiftModal
